const fullTexts =[
  {
    "name": "课题01",
    "parent": "立式成型充填封口机",
    "type": "document",
    "id":"da3ebe1f-52b3-4100-a677-f0a728362594",

  },
  {
    "name": "课题02",
    "parent": "立式成型充填封口机",
    "type": "document",
    "id":"2e42041a-dc5b-460f-abae-c63f81ed0e7d",

  },
  {
    "name": "课题03",
    "parent": "立式成型充填封口机",
    "type": "document",
    "id":"4fddc5c2-c7b6-4bf2-9cbb-87a9afa10875",

  },
  {
    "name": "其他",
    "parent": "立式成型充填封口机",
    "type": "document",
    "id":"3b035352-ebb6-4658-b2a9-b9730704f205",

  },
  {
    "name": "步骤1",
    "parent": "立式成型充填封口机",
    "type": "document",
    "id":"8dd1aa3f-a578-42d3-b6d7-72c06d0009b3",

  },
  {
    "name": "步骤2",
    "parent": "立式成型充填封口机",
    "type": "document",
    "id":"199963cf-ae44-48ab-9999-9a114cee4d52",

  },
  {
    "name": "步骤3",
    "parent": "立式成型充填封口机",
    "type": "document",
    "id":"89e0940a-d528-4a5d-ac51-d93c8b50c25e",

  },
  {
    "name": "步骤4",
    "parent": "立式成型充填封口机",
    "type": "document",
    "id":"b9687f4a-b55e-4526-beb1-66235cf54fea",

  },
  {
    "name": "课题01",
    "parent": "旋切刀具设备",
    "type": "document",
    "id":"9f892a2d-38ec-484f-8b35-64bc71d1570",

  },
  {
    "name": "课题02",
    "parent": "旋切刀具设备",
    "type": "document",
    "id":"e86f5762-f9ea-4ac0-ae88-ab3f21c20561",

  },
  {
    "name": "其他",
    "parent": "旋切刀具设备",
    "type": "document",
    "id":"6caf0763-d123-4f21-8419-c81f9929c88b",

  },
  {
    "name": "步骤1",
    "parent": "旋切刀具设备",
    "type": "document",
    "id":"63e4671c-fff2-4494-89f2-8904a6f23418",

  },
  {
    "name": "步骤2",
    "parent": "旋切刀具设备",
    "type": "document",
    "id":"c0ada25b-12c2-4425-8692-fa2b2eecc1ad",
  },
  {
    "name": "步骤3",
    "parent": "旋切刀具设备",
    "type": "document",
    "id":"6f52304c-18d7-47fa-8261-eb956bb6338b",

  },
  {
    "name": "课题01",
    "parent": "定位设备",
    "type": "document",
    "id":"38e0f708-38a0-4eec-850c-58f9669a3676",
  },
  {
    "name": "课题02",
    "parent": "定位设备",
    "type": "document",
    "id":"fde29923-1b87-4782-9a89-53ce0551bf00",

  },
  {
    "name": "课题03",
    "parent": "定位设备",
    "type": "document",
    "id":"6c76b00b-4687-4b37-a7c9-9d31753b09d4",

  },
  {
    "name": "其他",
    "parent": "定位设备",
    "type": "document",
    "id":"2cdd3a7c-2056-412f-a91d-142dfbea9f73",

  },
  {
    "name": "步骤1",
    "parent": "定位设备",
    "type": "document",
    "id":"7ad5528a-4c88-4b4c-b3c7-5b5f7d203729",

  },
  {
    "name": "步骤2",
    "parent": "定位设备",
    "type": "document",
    "id":"06cc5723-999a-44d4-8b92-e6093b810065",

  },
  {
    "name": "步骤3",
    "parent": "定位设备",
    "type": "document",
    "id":"133ea090-a38d-4c10-8db9-f66e700afa1b",

  },
  {
    "name": "步骤4",
    "parent": "定位设备",
    "type": "document",
    "id":"b88848ed-a580-49d0-ba0f-54aa726fb453",

  },
  {
    "name": "课题01",
    "parent": "使用龙门机构的设备",
    "type": "document",
    "id":"0364dc0b-1883-4f5a-b30f-8e217bd289ff",

  },
  {
    "name": "课题02",
    "parent": "使用龙门机构的设备",
    "type": "document",
    "id":"18fe6a5d-1ea7-4913-9e06-3f91246bd652",

  },
  {
    "name": "课题03",
    "parent": "使用龙门机构的设备",
    "type": "document",
    "id":"eaa5bf27-bdc1-4755-a98c-fb3647649e1e",

  },
  {
    "name": "其他",
    "parent": "使用龙门机构的设备",
    "type": "document",
    "id":"3fd9eed4-6d08-4c56-b3b4-345c3e4e92f0",

  },
  {
    "name": "步骤1",
    "parent": "使用龙门机构的设备",
    "type": "document",
    "id":"34511ab7-b92f-4921-a4c7-80cc99a53b9b",

  },
  {
    "name": "步骤2",
    "parent": "使用龙门机构的设备",
    "type": "document",
    "id":"746ef215-15b4-4c16-8354-7d435dc9ab7e",

  },
  {
    "name": "步骤3",
    "parent": "使用龙门机构的设备",
    "type": "document",
    "id":"9a18f44b-eec3-47e3-964a-1ad35d0575f3",

  },
  {
    "name": "步骤4",
    "parent": "使用龙门机构的设备",
    "type": "document",
    "id":"47f7a239-53e6-46c0-9341-f75feaec0ee1",

  },
  {
    "name": "课题01",
    "parent": "抓取机械手",
    "type": "document",
    "id":"18be0099-f117-4604-8ccc-25ef4f5abbde",

  },
  {
    "name": "课题02",
    "parent": "抓取机械手",
    "type": "document",
    "id":"22b5f382-42a8-43b5-9a60-ad08ac5f829d",

  },
  {
    "name": "课题03",
    "parent": "抓取机械手",
    "type": "document",
    "id":"f495117-d7d4-451b-acbf-d23505e687f0",

  },
  {
    "name": "其他",
    "parent": "抓取机械手",
    "type": "document",
    "id":"e2de1754-ab96-4932-8c17-4e539ef0b6cb",

  },
  {
    "name": "步骤1",
    "parent": "抓取机械手",
    "type": "document",
    "id":"a165c431-f051-45fe-90c9-738adc50cb39",

  },
  {
    "name": "步骤2",
    "parent": "抓取机械手",
    "type": "document",
    "id":"d52c56f2-6183-4530-b625-79b5aa2594fa",

  },
  {
    "name": "步骤3",
    "parent": "抓取机械手",
    "type": "document",
    "id":"add9d56f-4aea-4108-b2ba-771a29938e62",

  },
  {
    "name": "步骤4",
    "parent": "抓取机械手",
    "type": "document",
    "id":"6e172a4a-3b70-4259-ac01-ad1435657a9b",

  },
  {
    "name": "课题01",
    "parent": "压入设备",
    "type": "document",
    "id":"650c8203-9777-4729-8fe5-e4fdb707b7ac",

  },
  {
    "name": "课题02",
    "parent": "压入设备",
    "type": "document",
    "id":"09e50e48-4790-4f69-bfff-27f6c4a14ab4",

  },
  {
    "name": "其他",
    "parent": "压入设备",
    "type": "document",
    "id":"9bd2348c-e49b-4635-bd48-306211449497",

  },
  {
    "name": "步骤1",
    "parent": "压入设备",
    "type": "document",
    "id":"4c14b930-6727-4c5f-9324-35d369646a7b",

  },
  {
    "name": "步骤2",
    "parent": "压入设备",
    "type": "document",
    "id":"9ffae9b8-2330-4ba8-9e26-8ca67bfd5c8c",

  },
  {
    "name": "课题01",
    "parent": "使用安全监控功能的生产线",
    "type": "document",
    "id":"41f08e7b-6f62-4972-aebf-3e37bb7c9f20",

  },
  {
    "name": "课题02",
    "parent": "使用安全监控功能的生产线",
    "type": "document",
    "id":"d3c0fb83-8707-4ea2-8b84-c4a3b6597b5b",

  },
  {
    "name": "其他",
    "parent": "使用安全监控功能的生产线",
    "type": "document",
    "id":"4e1e0133-3ccb-41a1-8e5e-a362f6598171",

  },
  {
    "name": "步骤1",
    "parent": "使用安全监控功能的生产线",
    "type": "document",
    "id":"b023e69a-ebf2-44b0-a908-e0075121e051",

  },
  {
    "name": "步骤2",
    "parent": "使用安全监控功能的生产线",
    "type": "document",
    "id":"674bbf52-683c-442f-9bb4-457a4b202e5a",

  },
  {
    "name": "步骤3",
    "parent": "使用安全监控功能的生产线",
    "type": "document",
    "id":"83af9114-d354-404d-983e-eb393f070cc6",

  },
  {
    "name": "课题01",
    "parent": "节能搬送设备",
    "type": "document",
    "id":"f3501510-5609-4926-91a9-06b30aee3f4d",

  },
  {
    "name": "课题02",
    "parent": "节能搬送设备",
    "type": "document",
    "id":"f9e5b118-fcf5-4ebd-b989-a816f68432f5",

  },
  {
    "name": "课题03",
    "parent": "节能搬送设备",
    "type": "document",
    "id":"38629882-e162-4117-a8c0-2e4a27324c97",

  },
  {
    "name": "其他",
    "parent": "节能搬送设备",
    "type": "document",
    "id":"71054b3d-38e7-472e-b6e7-b051b84946a4",

  },
  {
    "name": "步骤1",
    "parent": "节能搬送设备",
    "type": "document",
    "id":"3d8c5a38-2dd0-4c8d-bd73-6ea8bf2c774e",

  },
  {
    "name": "步骤2",
    "parent": "节能搬送设备",
    "type": "document",
    "id":"e7154ffa-4fc8-4013-96fd-559c278e36b7",

  },
  {
    "name": "步骤3",
    "parent": "节能搬送设备",
    "type": "document",
    "id":"85bccb54-4e64-4b3a-b3fe-2ad20a9a1bcc",

  },
  {
    "name": "课题01",
    "parent": "旋切设备",
    "type": "document",
    "id":"7e185104-1db9-49e3-a1ea-9b6722253f6a",

  },
  {
    "name": "课题02",
    "parent": "旋切设备",
    "type": "document",
    "id":"d1ad3303-53de-4879-b355-6e05aa3ab1b4",

  },
  {
    "name": "其他",
    "parent": "旋切设备",
    "type": "document",
    "id":"4d518b06-5068-41a5-8a58-d1e04f64c02a",

  },
  {
    "name": "步骤1",
    "parent": "旋切设备",
    "type": "document",
    "id":"dab5f784-56bb-4d90-95a1-a0d9f2a6609b",

  },
  {
    "name": "步骤2",
    "parent": "旋切设备",
    "type": "document",
    "id":"3bd2a8ec-495d-46d4-8d19-ac367d790c32",

  },
  {
    "name": "步骤3",
    "parent": "旋切设备",
    "type": "document",
    "id":"39526059-c2c2-48fb-9063-7486e850ba02",

  },
  {
    "name": "步骤4",
    "parent": "旋切设备",
    "type": "document",
    "id":"97f014c6-6635-4489-b5a9-750739aa1858",

  },
  {
    "name": "课题01",
    "parent": "拧紧机设备",
    "type": "document",
    "id":"957edd4b-d012-4b8c-b779-d1ae27470add",

  },
  {
    "name": "课题02",
    "parent": "拧紧机设备",
    "type": "document",
    "id":"d0fe8869-bbe2-411d-99bf-ebe8b57386df",

  },
  {
    "name": "其他",
    "parent": "拧紧机设备",
    "type": "document",
    "id":"fd288942-e173-489f-a58a-886678275eca",

  },
  {
    "name": "步骤1",
    "parent": "拧紧机设备",
    "type": "document",
    "id":"5564509e-ae9c-4bfe-84b8-c56eb4caf3f8",

  },
  {
    "name": "步骤2",
    "parent": "拧紧机设备",
    "type": "document",
    "id":"65910072-ad5d-4be1-bc10-9c1fc98cef35",

  },
  {
    "name": "步骤3",
    "parent": "拧紧机设备",
    "type": "document",
    "id":"4dd3df8b-2fe9-4147-8a86-e2641e553f88",

  },
  {
    "name": "陶瓷",
    "parent": "变频器行业应用",
    "type": "document",
    "children": [
      {
        "type": "heading-one",
        "children": [
          {
            "text": "陶瓷",
            "bold": true
          }
        ]
      },
      {
        "type": "paragraph",
        "children": [
          {
            "type": "image",
            "src": "https://lite.ivymobi.net/cdn//f19fb95e-eda6-49ba-af93-70ddce588269/3b4d4cb3-42f3-4649-8ca9-73c2f87eeee7.jpeg"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "heading-undefined",
        "children": [
          {
            "text": "▶ 用于防止传动带上面所载货物的振动。可以缓和加减速时的振动效果，有效防止货物翻倒等情况。"
          }
        ]
      },
      {
        "type": "paragraph",
        "children": [
          {
            "text": "由于从当前频率到目标频率始终为S曲线加减速，因此可以缓和加减速时的振动，有效的防止货物翻倒。将Pr.29设定为“2&quot;时便可使用此功能。"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "heading-undefined",
        "children": [
          {
            "text": "相关变频器"
          }
        ]
      },
      {
        "type": "blockquote",
        "children": [
          {
            "type": "paragraph",
            "children": [
              {
                "text": "A800",
                "bold": true
              }
            ]
          }
        ]
      },
      {
        "type": "blockquote",
        "children": [
          {
            "type": "paragraph",
            "children": [
              {
                "text": "F800",
                "bold": true
              }
            ]
          }
        ]
      },
      {
        "type": "blockquote",
        "children": [
          {
            "type": "paragraph",
            "children": [
              {
                "text": "E800",
                "bold": true
              }
            ]
          }
        ]
      },
      {
        "type": "blockquote",
        "children": [
          {
            "type": "paragraph",
            "children": [
              {
                "text": "D700",
                "bold": true
              }
            ]
          }
        ]
      },
      {
        "type": "blockquote",
        "children": [
          {
            "type": "paragraph",
            "children": [
              {
                "text": "CS80",
                "bold": true
              }
            ]
          }
        ]
      },
      {
        "type": "paragraph",
        "children": [
          {
            "text": "FR-A800FR-A700FR-F800FR-F700FR-E700FR-EJ740FR-D700"
          }
        ]
      }
    ]
  },
  {
    "name": "纺织印染",
    "parent": "变频器行业应用",
    "type": "document",
    "children": [
      {
        "type": "heading-one",
        "children": [
          {
            "text": "纺织",
            "bold": true
          }
        ]
      },
      {
        "type": "paragraph",
        "children": [
          {
            "type": "image",
            "src": "https://lite.ivymobi.net/cdn//f19fb95e-eda6-49ba-af93-70ddce588269/d68701e9-0b67-4d8a-9f9f-7bd8d546b9d8.jpeg"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "heading-undefined",
        "children": [
          {
            "text": "▶ 三角波"
          }
        ]
      },
      {
        "type": "paragraph",
        "children": [
          {
            "text": "依照一定的周期，通过三角波运行使频率产生振幅。"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "paragraph",
        "children": [
          {
            "type": "image",
            "src": "https://lite.ivymobi.net/cdn//f19fb95e-eda6-49ba-af93-70ddce588269/5f190af6-8a6f-4ce1-8bf3-a07753096362.jpeg"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "heading-undefined",
        "children": [
          {
            "text": "▶ 反转防止"
          }
        ]
      },
      {
        "type": "paragraph",
        "children": [
          {
            "text": "能够防止由于错误输入启动信号而导致的反转事故。"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "heading-undefined",
        "children": [
          {
            "text": "▶ 标准内置RS-485通信"
          }
        ]
      },
      {
        "type": "paragraph",
        "children": [
          {
            "text": "三菱变频器协议和Modbus-RTU协议RS-485的通讯速度最大为19.2kbps追加三菱变频器协议的多重命令模块(可将变频器的原有数据处理时间缩短至1/3~1/4)也同样对应Modbus-RTU协议"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "heading-undefined",
        "children": [
          {
            "text": "▶ Point"
          }
        ]
      },
      {
        "type": "paragraph",
        "children": [
          {
            "text": "在纱锭成形过程中，通过三角波功能，使纱锭没有鼓包、平整如一。配合反转防止功能可保证纱锭始终保持同一转向。"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "hr",
        "children": []
      },
      {
        "type": "heading-one",
        "children": [
          {
            "text": "纺织机械行业解决方案",
            "bold": true
          }
        ]
      },
      {
        "type": "paragraph",
        "children": [
          {
            "text": "专业的行业功能保证了纺机设备的安全运行，提高了纺纱质量及生产效率。适合于纺织机械设备的应用(如染色机、粗/细纱机等)"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "heading-undefined",
        "children": [
          {
            "text": "▶ 纺织机械-染色机"
          }
        ]
      },
      {
        "type": "bulleted-list",
        "children": [
          {
            "type": "list-item",
            "children": [
              {
                "text": "通过液流或气流对布及原料进行染色的装置。包括在布料上进行印花、印字等印花机设备等。"
              }
            ]
          },
          {
            "type": "list-item",
            "children": [
              {
                "text": "收卷/放卷通常使用变频器速度控制和浮动辊控制进行。"
              }
            ]
          },
          {
            "type": "list-item",
            "children": [
              {
                "text": "张布架部分需要进行张力控制，通常使用变频器力矩功能实现。"
              }
            ]
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "paragraph",
        "children": [
          {
            "type": "image",
            "src": "https://lite.ivymobi.net/cdn//f19fb95e-eda6-49ba-af93-70ddce588269/496bb3d4-f84d-4ed0-981f-d1fcd33a57ab.jpeg"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "paragraph",
        "children": [
          {
            "type": "image",
            "src": "https://lite.ivymobi.net/cdn//f19fb95e-eda6-49ba-af93-70ddce588269/5b08e19b-f9aa-4dc7-af39-9e22a680814e.jpeg"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "heading-undefined",
        "children": [
          {
            "text": "▶ 纺织机械-粗/细纱机"
          }
        ]
      },
      {
        "type": "paragraph",
        "children": [
          {
            "type": "image",
            "src": "https://lite.ivymobi.net/cdn//f19fb95e-eda6-49ba-af93-70ddce588269/a8886020-b4b2-48bb-aaf6-e52c39129d33.jpeg"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "paragraph",
        "children": [
          {
            "text": "三角波功能(摆频) ----高速绕制纱锭，成型平整，不鼓包。 "
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "paragraph",
        "children": [
          {
            "type": "image",
            "src": "https://lite.ivymobi.net/cdn//f19fb95e-eda6-49ba-af93-70ddce588269/4919ff0c-e69c-4364-a81c-5eb310b05550.jpeg"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "paragraph",
        "children": [
          {
            "type": "image",
            "src": "https://lite.ivymobi.net/cdn//f19fb95e-eda6-49ba-af93-70ddce588269/4a6f9eb6-63a8-469c-9454-90bde6108f22.jpeg"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "paragraph",
        "children": [
          {
            "text": "停电停止功能----适合在粗/细纺机等设备中使用，断电时可避免因设备失去动力而自由运行造成的纱线松弛或断裂。"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "paragraph",
        "children": [
          {
            "type": "image",
            "src": "https://lite.ivymobi.net/cdn//f19fb95e-eda6-49ba-af93-70ddce588269/b37fe4f7-ee7d-408e-816b-e48bab072be8.jpeg"
          }
        ]
      },
      {
        "type": "space",
        "children": []
      },
      {
        "type": "heading-undefined",
        "children": [
          {
            "text": "相关变频器"
          }
        ]
      },
      {
        "type": "blockquote",
        "children": [
          {
            "type": "paragraph",
            "children": [
              {
                "text": "A800",
                "bold": true
              }
            ]
          }
        ]
      },
      {
        "type": "blockquote",
        "children": [
          {
            "type": "paragraph",
            "children": [
              {
                "text": "F800",
                "bold": true
              }
            ]
          }
        ]
      },
      {
        "type": "blockquote",
        "children": [
          {
            "type": "paragraph",
            "children": [
              {
                "text": "E800",
                "bold": true
              }
            ]
          }
        ]
      },
      {
        "type": "blockquote",
        "children": [
          {
            "type": "paragraph",
            "children": [
              {
                "text": "D700",
                "bold": true
              }
            ]
          }
        ]
      },
      {
        "type": "blockquote",
        "children": [
          {
            "type": "paragraph",
            "children": [
              {
                "text": "CS80",
                "bold": true
              }
            ]
          }
        ]
      }
    ]
  },
    {
    "name": "A800系列",
    "parent": "",
    "type": "document",
    "id":"29ad90dd-4855-4751-83d7-f3260ae31170",
  },
  {
    "name": "E800系列",
    "parent": "",
    "type": "document",
    "id":"65976e85-ebfb-44af-9d14-aea18761294b",
  }, {
    "name": "D700系列",
    "parent": "",
    "type": "document",
    "id":"4c0fffed-fb8f-4533-9369-17a69297ff21",
  }, {
    "name": "F800系列",
    "parent": "",
    "type": "document",
    "id":"9f3d7396-df8d-4087-a544-87b8084e2074",
  },
  
];

export default fullTexts;